<template>
  <div v-if="force_show || worksTotalOnMap>0" :class="button_class" :style="button_style">

    <!-- страница всех работ v8 -->
    <button v-if="theme=='main' && worksTotalOnMap>0" class="button-default button-default_size-40 button-default_color-grey" v-on:click="show_popup">
      <div class="svg-icon">
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 10C6.9 10 6 9.1 6 8C6 6.9 6.9 6 8 6C9.1 6 10 6.9 10 8C10 9.1 9.1 10 8 10ZM8 0C3.8 0 0 3.22 0 8.2C0 11.52 2.67 15.45 8 20C13.33 15.45 16 11.52 16 8.2C16 3.22 12.2 0 8 0Z"/></svg>
      </div>
      <span class="button-default__delimiter"/>
      <span class="button-default__name nowrap">{{$t('message.WorksOnMap')}}</span>
    </button>

    <!-- блок на странице художника/галереи перед картинами  -->
    <!--<a v-if="theme=='' && worksTotalOnMap>0 && (to_artist_id>0 || to_gallery_id>0)" v-on:click="show_popup" class="works-location link pointer">
      <div class="delimiter"/>
      <div class="works-location__wrapper">
        <div v-if="to_artist_id>0" class="works-location__title h3 h3_bold works-location__h3" v-html="$t('message.WorksOnMapArtist')"/>
        <div v-if="to_gallery_id>0" class="works-location__title h3 h3_bold works-location__h3" v-html="$t('message.WorksOnMapGallery')"/>

        <div class="works-location__icon"/>
      </div>
      <div class="delimiter"/>
    </a>-->

    <!-- на субдомене -->
    <!-- classic_light & classic_dark выводится не здесь -->
    <div v-if="(theme=='air_light' || theme=='air_dark') && worksTotalOnMap>0" class="all-work__map works-location__title works-location__h3">
      <img class="all-work__marker" src="/res/subdomains/img/all-work__marker.svg" alt="marker icon"/>
      <a class="all-work__link pointer" v-on:click="show_popup">{{$t('message.WorksOnMap')}}</a>
    </div>
    <a v-if="theme=='flat_light' && worksTotalOnMap>0" class="all-work__map works-location__title works-location__h3 pointer" v-on:click="show_popup">
      <div class="all-work__marker">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.9999 4.48003C16.4086 2.88873 14.2504 1.99475 11.9999 1.99475C9.74949 1.99475 7.59123 2.88873 5.99993 4.48003C4.40863 6.07133 3.51465 8.2296 3.51465 10.48C3.51465 12.7305 4.40863 14.8887 5.99993 16.48L11.2699 21.76C11.3629 21.8538 11.4735 21.9282 11.5954 21.9789C11.7172 22.0297 11.8479 22.0558 11.9799 22.0558C12.1119 22.0558 12.2426 22.0297 12.3645 21.9789C12.4864 21.9282 12.597 21.8538 12.6899 21.76L17.9999 16.43C19.5846 14.8454 20.4748 12.6961 20.4748 10.455C20.4748 8.21398 19.5846 6.06471 17.9999 4.48003ZM16.5699 15L11.9999 19.59L7.42993 15C6.52707 14.0963 5.91241 12.9453 5.66362 11.6923C5.41484 10.4394 5.54312 9.14078 6.03223 7.96071C6.52135 6.78065 7.34935 5.77208 8.41156 5.06251C9.47377 4.35294 10.7225 3.97421 11.9999 3.97421C13.2773 3.97421 14.5261 4.35294 15.5883 5.06251C16.6505 5.77208 17.4785 6.78065 17.9676 7.96071C18.4567 9.14078 18.585 10.4394 18.3362 11.6923C18.0875 12.9453 17.4728 14.0963 16.5699 15ZM8.99993 7.41003C8.19264 8.2198 7.73932 9.3166 7.73932 10.46C7.73932 11.6035 8.19264 12.7003 8.99993 13.51C9.59969 14.1108 10.3635 14.5211 11.1956 14.6894C12.0276 14.8578 12.8909 14.7766 13.677 14.4562C14.4631 14.1358 15.1371 13.5903 15.6144 12.8883C16.0917 12.1863 16.3511 11.3589 16.3599 10.51C16.3644 9.94324 16.2553 9.38129 16.0388 8.85742C15.8224 8.33355 15.5032 7.85839 15.0999 7.46003C14.7036 7.05461 14.231 6.73157 13.7094 6.5095C13.1877 6.28743 12.6273 6.17071 12.0603 6.16606C11.4934 6.16141 10.9311 6.26893 10.4059 6.48242C9.88067 6.69591 9.40285 7.01116 8.99993 7.41003ZM13.6899 12.09C13.311 12.4748 12.8101 12.7159 12.2731 12.7723C11.736 12.8286 11.196 12.6967 10.7454 12.399C10.2949 12.1012 9.96173 11.6563 9.80294 11.1401C9.64415 10.624 9.66958 10.0687 9.87489 9.56919C10.0802 9.06971 10.4526 8.65705 10.9285 8.40177C11.4044 8.14649 11.9542 8.06444 12.4839 8.16965C13.0135 8.27486 13.4902 8.56079 13.8324 8.97856C14.1746 9.39634 14.3611 9.92 14.3599 10.46C14.3454 11.0773 14.0864 11.6636 13.6399 12.09H13.6899Z"></path>
        </svg>
      </div>
      {{$t('message.WorksOnMap')}}
    </a>

    <!-- попап -->
    <div class="works-map js-works-map" id="id_works_map_container" style="z-index: 501;" v-show="is_popup_showed">
      <div class="works-map__wrapper">
        <!-- развернуть список работ -->
        <a style="right: 70px;" onclick="$('#id_works_map_container').addClass('open')" class="button-default button-default_icon button-default_size-40 button-default_color-white button-default_bx-shadow-grey show-md-flex works-map__open-button js-works-map-open-button pointer">
          <div class="svg-icon svg-icon_size-16px">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewbox="0 0 16 16"><path d="M5.82857 7.77817L12.1925 14.1421L10.7783 15.5563L3.00015 7.77817L10.7783 0L12.1925 1.41421L5.82857 7.77817Z"/></svg>
          </div>
        </a>
        <!-- close popup, когда список работ скрыт -->
        <a v-on:click="hide_popup" class="button-default button-default_icon button-default_size-40 button-default_color-white button-default_bx-shadow-grey show-md-flex works-map__open-button js-works-map-open-button pointer">
          <div class="svg-icon svg-icon_size-14px">
            <span class="svg-close"></span>
          </div>
        </a>

        <div class="works-map__map" id="id_works_map"/>

        <div class="works-map__filter">
          <div class="works-map__filter-header">
            <div class="works-map__filter-container">
              <div class="works-map__filter-search">
                <!-- свернуть список работ -->
                <a onclick="$('#id_works_map_container').removeClass('open')" class="button-default button-default_icon button-default_size-40 button-default_color-grey works-map__close-button show-md-flex js-works-map-close-button pointer">
                  <div class="svg-icon svg-icon_size-16px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewbox="0 0 16 16"><path d="M12.7278 7.77817L6.36386 14.1421L7.77808 15.5563L15.5563 7.77817L7.77808 0L6.36386 1.41421L12.7278 7.77817Z" transform="translate(-2,0)"/></svg>
                  </div>
                </a>

                <div class="dropdown works-map__search-dropdown" id="id_qseqrch_mapcity" onkeydown="stop_bubble(event)">
                  <dropdown_qsearch
                    v-model="qsearch_city"
                    :placeholder="$t('message.QSearchcity')"
                    main_class="input input_dropdown input_size-40 input_animate-label"
                    url_html="/action/qsearch?type=city_coords&v=7&search="
                    url_html_init="/action/qsearch?action=restore_search&section=city_coords&v=7"
                    :input_class="get_input_class"/>
                </div>

                <!-- close popup, когда список работ раскрыт -->
                <a v-on:click="hide_popup" class="button-default button-default_icon button-default_size-40 button-default_color-grey works-map__clear-button pointer">
                  <div class="svg-icon svg-icon_size-14px">
                    <span class="svg-close"></span>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="delimiter"/>
          <div class="works-map__filter-body" id="id_map_scrollbar">
            <ul class="works-map__list">

              <li v-for="work in list_works" class="works-map__list-item" v-on:mouseover="mouseover_item( work )" v-on:mouseleave="mouseleave_item( work )">
                <div class="works-map__list-link" :coverage_uri="getWorkUri(work)">
                  <a :href="getWorkUrl(work)" target="_blank">
                    <div :class="is_mark_work_pro?getWorkClass(work):''" class="works-map__list-image" :style="getWorkBackground(work)" style="position: relative">
                      <div v-if="getWorkPrice(work)!=''" class="cl_map_work_cost item-cost" :class="work.status.is_negotiated=='y'?'item-green':''">
                        {{getWorkPrice(work)}}
                      </div>
                    </div>
                  </a>

                  <div class="works-map__list-caption">
                    <a class="black" :href="getWorkUrl(work)" target="_blank">
                      <div class="works-map__list-text">
                        {{work.artist.full_name}}, {{work.name}}
                      </div>
                      <div class="works-map__list-text">
                        <span v-if="work.sx>0 && work.sy>0">{{show_num(work.sy/10)}}×{{show_num(work.sx/10)}} {{ $t("message.sm") }}</span><span v-if="work.sx>0 && work.sy>0 && getWorkYear(work).length>0">, </span>
                        <span v-if="getWorkYear(work).length>0">{{getWorkYear(work)}}</span>
                      </div>
                    </a>

                    <a v-if="work['owner']!=null && work.owner.name.length>0" :href="work.owner.link" target="_blank">
                      <div class="works-map__list-text">
                        {{work.owner.name_object}}
                        {{work.owner.name}}
                      </div>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div style="display: none">{{testMap}}</div><!-- просто чтобы calck сработал -->
  </div>
</template>


<script>
  import mixin_work from '../../../mixins/mixin_work';
  import dropdown_qsearch from "../../lib/dropdown_qsearch";

  export default {
    mixins: [mixin_work],
    components: { dropdown_qsearch },
    name: 'on-map',
    props: {
      is_mark_work_pro: [Boolean],
      theme: { type: String, default: '' },
      button_style: { type: String, default: 'width: auto;margin-right: 10px' },
      button_class: { type: String, default: 'block-sorter bs_works' },
    },
    data() {
      return {
        to_artist_id: $('#app-wrapper').attr('artist_id'),
        to_gallery_id: $('#app-wrapper').attr('gallery_id'),

        is_show_on_map_param:true,
        is_popup_showed: false,
        is_first_show:true,

        l_map: null,
        l_markers:{},
        marker_group: null,
        l_layers:{},
        layer_group: null,
        T_interval:null,


        popup_works_page:1,
        list_works_page:1,
        list_works:[],
        force_show:true,

        is_load_works:false,
        is_load_popup_works:false,
      }
    },

    computed: {
      get_input_class:{
        get () {
          let cl='';
          switch (this.theme){
            case 'air_light':
            case 'air_dark':
              cl='ref-input ref-input-md ref-input-block';
              break;

            case 'flat_light':
              cl='contact__input no_margin';
              break;
          }

          return cl;
        }
      },

      worksTotalOnMap: {
        get () {
          return parseInt(this.$store.getters.worksTotalOnMap);
        }
      },

      testMap: {
        get () {
          let res=this.$store.getters.modificators;
          if ( res['map']!=null && this.is_show_on_map_param /*&& this.worksTotalOnMap>0*/ ){
            this.$nextTick( ()=>{
              this.show_popup();
            } );
            //setTimeout( ()=>{this.show_popup();}, 10 );
          }
          else {
            this.force_show=true;
          }

          return res;
        }
      },

      qsearch_city:{
        get () {
          return '';
        },

        set(valueObj) {
          if(!valueObj) return false;

          let value = valueObj.value;
          if (value !== undefined && value.length>0) {
            let parts=value.split(':');
            let lat=parts[0];
            let lon=parts[1];

            this.l_map.flyTo([lat, lon], 11);

            setTimeout( ()=>{
              $('#id_qseqrch_mapcity input').blur();
            }, 100 );
          }
        }
      }
    },

    methods: {
      meters_per_pixel(latitude, zoomLevel){
        var earthCircumference = 40075017;
        var latitudeRadians = latitude * (Math.PI/180);
        return earthCircumference * Math.cos(latitudeRadians) / Math.pow(2, zoomLevel + 8);
      },
      meters_to_pixels(latitude, meters, zoomLevel){
        return meters / this.meters_per_pixel(latitude, zoomLevel);
      },
      pixels_to_meters(latitude, pixels, zoomLevel){
        return pixels*this.meters_per_pixel(latitude, zoomLevel);
      },

      animate_radius(l_layer, new_radius, time){
        clearInterval(this.T_interval);

        let min_time=50;
        let cnt_iterations=time/min_time;

        let current_radius = l_layer.getRadius();
        let dr=(new_radius-current_radius)/cnt_iterations;

        this.T_interval = setInterval(function() {
          let current_radius = l_layer.getRadius();
          if ( (current_radius < new_radius && dr>0)||(current_radius > new_radius && dr<0) ) {
            let set_radius=current_radius+dr;
            if ( (set_radius>new_radius && dr>0)||(set_radius<new_radius && dr<0) ) set_radius=new_radius;
            l_layer.setRadius(set_radius);
          }
          else {
            clearInterval(this.T_interval);
          }
        }, min_time);
      },

      mouseover_item(work){
        for (var cluster_id in this.l_markers) {
          let l_marker=this.l_markers[cluster_id];
          l_marker.setZIndexOffset(1);
        }
        for (var cluster_id in this.l_layers) {
          let l_layer=this.l_layers[cluster_id];
          l_layer.bringToBack();
        }

        if ( work['cluster_ids']!=null ){
          work['cluster_ids'].forEach( (cluster_id, n)=>{
            if ( this.l_markers[ cluster_id ]!=null ){
              this.l_markers[ cluster_id ].setZIndexOffset(2);
              $('.cl_icon_'+cluster_id).addClass('lmap_icon_over');
            }

            if ( this.l_layers[ cluster_id ]!=null ){
              let l_layer=this.l_layers[ cluster_id ];

              l_layer.bringToFront();
              let cur_radius=$( l_layer ).data('cur_radius');
              if ( cur_radius==null ) {
                cur_radius=l_layer.getRadius();
                $( l_layer ).data('cur_radius', cur_radius);
              }
              let new_radius=cur_radius+this.pixels_to_meters( l_layer.getLatLng().wrap().lat, 10, this.l_map.getZoom() );
              this.animate_radius(l_layer, new_radius, 250);
            }
          });
        }
      },

      mouseleave_item(work){
        if ( work['cluster_ids']!=null ){
          work['cluster_ids'].forEach( (cluster_id, n)=>{
            $('.cl_icon_'+cluster_id).removeClass('lmap_icon_over');

            if ( this.l_layers[ cluster_id ]!=null ){
              let l_layer=this.l_layers[ cluster_id ];
              if ( $( l_layer ).data('cur_radius')!=null ) {
                this.animate_radius(l_layer, $( l_layer ).data('cur_radius'), 250);
              }
            }
          });
        }
      },

      getWorkBackground(work) {
        return 'background-image:url("'+this.getWorkSrc(work, 'sx100')+'");';
      },

      _map_init(){
        if ( !$('#id_works_map').is(":visible") || $('#id_works_map').is(":hidden") ){
          setTimeout( ()=>{
            //подождём пока появится контейнер
            this._map_init();
          }, 100 );
          return;
        }

        let options={zoom_slider:true, scale:true};
        let zoom=localStorage.getItem('works_map_zoom');
        let center_lat=localStorage.getItem('works_map_lat');
        let center_lon=localStorage.getItem('works_map_lon');
        if ( zoom!=null && center_lat!=null && center_lon!=null ){
          options['zoom']=zoom;
          options['lat']=center_lat;
          options['lon']=center_lon;
        }

        var this_=this;
        this.l_map=window.model_map.init_map( 'id_works_map', options, function(){
          let l_map=this;
          this_.l_map=l_map;

          l_map.on('moveend', function(){this_.do_update();});
          this_.marker_group = L.layerGroup().addTo(l_map);
          this_.layer_group = L.layerGroup().addTo(l_map);

          this_.do_update(true);
        } );
      },

      show_popup(){
        this.is_show_on_map_param=false;
        this.$store.dispatch('setModificator', 'map');

        window.model_big_popup.lockContainer( 'auto' );
        this.is_popup_showed=true;

        if ( this.is_first_show ){
          window.global.body_key_bind( 'bigmap', 27, ()=>{ this.hide_popup() } );

          /*Begin инит карты*/
          this._map_init();

          //инит скроллера
          window.global.init_scrollbar_lq('#id_map_scrollbar', {
            'onScroll': (y, x)=>{
              if(y.scroll>0 &&  y.scroll+350 >= y.maxScroll){
                this._do_load_list_next();
              }
            }
          });
          /*End инит карты*/

          this.is_first_show=false;
        }
        else {
          //удаляем все маркеры
          this.marker_group.clearLayers();
          this.l_markers={};

          this.layer_group.clearLayers();
          this.l_layers={};

          //удаляем список работ
          this.list_works.splice(0);
          this.list_works_page=1;
          this.popup_works_page=1;

          this.do_update();
        }
      },

      hide_popup(){
        this.is_show_on_map_param=false;
        this.$store.dispatch('removeModificator', 'map');

        window.model_big_popup.unlockContainer();
        this.is_popup_showed=false;
      },

      get_popup_html_lis( works ){
        if ( works==null || works.length==0 ) return '';

        let result='';

        works.forEach( (work, n)=>{
          let price=this.getWorkPrice(work);
          let add_class='';
          if ( work.status.is_negotiated=='y' ) add_class='item-green';
          if ( price!='' ) price='<div class="cl_map_work_cost item-cost '+add_class+'">'+price+'</div>';

          let add='';
          if (work.sx>0 && work.sy>0) add+=this.show_num(work.sy/10)+'×'+this.show_num(work.sx/10)+' '+ this.$t("message.sm");
          let year=this.getWorkYear(work);
          if ( add!='' && year.length>0 ) add+=', ';
          add+=year;

          let add_pro=this.is_mark_work_pro?this.getWorkClass(work):'';

          let add_owner='';
          if ( work['owner']!=null && work.owner.name.length>0 ){
            add_owner=
              '<a href="'+work.owner.link+'" target="_blank">'+
                '<div class="works-map__list-text">'+
                  work.owner.name_object+
                  ' '+
                  work.owner.name+
                '</div>'+
              '</a>';
          }

          let html='' +
            '<li class="works-map__list-item"  coverage_uri="'+this.getWorkUri(work)+'">' +
              '<div class="works-map__list-link">' +
                '<a href="'+this.getWorkUrl(work)+'" target="_blank">' +
                  '<div class="works-map__list-image '+add_pro+'" style=\'position: relative; '+this.getWorkBackground(work)+'\'>' +
                    price +
                  '</div>' +
                '</a>' +
                '<div class="works-map__list-caption">' +
                  '<a class="black" href="'+this.getWorkUrl(work)+'" target="_blank">' +
                    '<div class="works-map__list-text">'+
                      work.artist.full_name+', '+work.name+
                    '</div>' +
                    '<div class="works-map__list-text">'+add+'</div>' +
                  '</a>' +
                  add_owner +
                '</div>' +
              '</div>' +
            '</li>';

          result+=html;
        } );

        return result;
      },
      get_popup_html( works ){
        if ( works==null || works.length==0 ) return '<div style="text-align: center;"><img class="c_spinner" src="'+window._GL_SITE_URL_CDN+'/res/img/svg/spinner-black.svg"/></div>';
        return '<div style="max-height: 200px" class="cl_map_popup"><ul class="works-map__list cl_map_ul_popup">'+this.get_popup_html_lis(works)+'</ul></div>';
      },

      do_update( is_first ){
        //обновление карты
        let bounds=this.l_map.getBounds();

        let lb_lat=bounds.getSouthWest().wrap().lat;
        let lb_lon=bounds.getSouthWest().wrap().lng;
        let rt_lat=bounds.getNorthEast().wrap().lat;
        let rt_lon=bounds.getNorthEast().wrap().lng;
        let zoom=this.l_map.getZoom();

        if ( lb_lat==rt_lat || lb_lon==rt_lon ){
          //что-то тут не так
          //this.l_map.off();this.l_map.remove(); - не работает
          setTimeout( ()=>{
            this.l_map.invalidateSize( false );
          }, 500 );
          return;
        }

        //сохраняем данные
        let center=this.l_map.getCenter().wrap();
        localStorage.setItem('works_map_zoom', zoom);
        localStorage.setItem('works_map_lat', center.lat);
        localStorage.setItem('works_map_lon', center.lng);

        this._do_update_map(lb_lat, lb_lon, rt_lat, rt_lon, zoom);
        this._do_update_list(lb_lat, lb_lon, rt_lat, rt_lon, zoom);
      },
      _do_update_map(lb_lat, lb_lon, rt_lat, rt_lon, zoom){
        //получаем кластеры на карте
        this.$store.dispatch('getWorksOnMap', {lb_lat:lb_lat, lb_lon:lb_lon, rt_lat:rt_lat, rt_lon:rt_lon, zoom:zoom, p:1}).then( ()=>{
          let works=this.$store.getters.works_on_map;
          if ( works!=null ){
            //удаляем маркеры, которых уже нет на карте
            let cluster_ids=[];
            works.forEach( (cluster, n)=> {
              cluster_ids.push(1*cluster['cluster_id']);
            });

            for (var cur_cluster_id in this.l_markers) {
              if ( cluster_ids.indexOf( 1*cur_cluster_id )<0 ){
                this.l_markers[cur_cluster_id].remove();
                delete this.l_markers[cur_cluster_id];
              }
            }
            for (var cur_cluster_id in this.l_layers) {
              if ( cluster_ids.indexOf( 1*cur_cluster_id )<0 ){
                this.l_layers[cur_cluster_id].remove();
                delete this.l_layers[cur_cluster_id];
              }
            }

            works.forEach( (cluster, n)=> {
              let cluster_id=cluster['cluster_id'];

              if ( this.l_markers[ cluster_id ]!=null ) {
                //такой на карте уже есть
                return;
              }

              //иконка маркера
              let l_icon=null;

              let lat=cluster['coords']['lat_w'];
              let lon=cluster['coords']['lon_w'];
              let l_marker=null;

              let radius=cluster['coords']['radius'];
              let next_zoom=1*cluster['coords']['next_zoom'];
              if (next_zoom>18) next_zoom=18;

              let f_zindex_marker=(l_marker)=>{
                for (var ncluster_id in this.l_markers) {
                  this.l_markers[ncluster_id].setZIndexOffset(1);
                }
                l_marker.setZIndexOffset(2);
              };

              if ( cluster['count']==1 ){
                //одна работа
                let work=cluster['works'][0];

                let src=this.getWorkSrc(work, 'sx40');
                let color_style=this.getWorkColorStyle(work);

                let icon_price=this.getWorkPrice(work);
                if ( icon_price!='' ) icon_price=', '+icon_price;

                l_icon = L.divIcon({
                  //className: 'custom-div-icon',
                  html: "<div style='"+color_style+"' class='lmap_icon cl_icon_"+cluster_id+"'><img title='"+work.artist.full_name+', '+work.name+icon_price+"' src='"+src+"' style='width: 30px; height: 30px'></div>",
                  iconSize: [30, 30],
                  popupAnchor: [0, -10],
                  //iconAnchor: [15, 42]
                });
                l_marker=window.L.marker([lat, lon], {draggable:false, icon:l_icon});
                l_marker.bindPopup(this.get_popup_html( cluster['works'] ), {closeButton:false});
                l_marker.on('click', ()=>{f_zindex_marker(l_marker);});
              }
              else if (radius==0 || next_zoom<=zoom) {
                //несколько штук в одной точке
                let count=cluster['count'];

                l_icon = L.divIcon({
                  //className: 'custom-div-icon',
                  html: "<div class='lmap_cluster lmap_cluster40 lmap_icon cl_icon_"+cluster_id+"'>"+this.show_num(count)+"</div>",
                  iconSize: [40, 40],
                  popupAnchor: [0, -10],
                  //iconAnchor: [15, 42]
                });
                l_marker=window.L.marker([lat, lon], {draggable:false, icon:l_icon});
                l_marker.bindPopup(this.get_popup_html(null), {closeButton:false});
                l_marker.on('click', ()=>{f_zindex_marker(l_marker);});

                //загрузка работ в попап
                $(l_marker).data('loaded', 0);
                l_marker.on('click', (e)=>{
                  var popup = e.target.getPopup();
                  this.popup_works_page=1;

                  let f_scroll_init=()=>{
                    let j_map_ul_popup=$('.cl_map_ul_popup', $(popup.getElement()));

                    window.global.init_scrollbar_lq('.cl_map_popup', {
                      'onScroll': (y, x)=>{
                        if(y.scroll>0 &&  y.scroll+350 >= y.maxScroll){
                          this._do_load_popup_next(cluster_id, popup, j_map_ul_popup);
                        }
                      }
                    }, '200px');
                  };

                  if ( $(l_marker).data('loaded')==0 ){
                    $(l_marker).data('loaded', 1);

                    this.$store.dispatch('getWorksOnMapCluster', {cluster_id:cluster_id, zoom:zoom, p:1}).then( ()=>{
                      let works=this.$store.getters.works_on_map_cluster;
                      popup.setContent( this.get_popup_html(works) );
                      popup.update();

                      f_scroll_init();
                    });
                  }
                  else {
                    f_scroll_init();
                  }
                });
              }
              else {
                //несколько штук в некотором радиусе
                let lat_avg=cluster['coords']['lat_avg'];
                let lon_avg=cluster['coords']['lon_avg'];

                let count=cluster['count'];

                let radius_in_pixels=this.meters_to_pixels(lat_avg, radius, zoom);
                let min_radius=22;//40/2 + 2
                let max_radius=60;//px

                if ( radius_in_pixels>max_radius ){
                  radius=this.pixels_to_meters( lat_avg, max_radius, zoom );
                }

                let add_class='lmap_cluster_transparent';
                if ( radius_in_pixels<=min_radius ) add_class='lmap_cluster_transparent05';

                l_icon = L.divIcon({
                  //className: 'custom-div-icon',
                  html: "<div class='lmap_cluster lmap_cluster40 "+add_class+" lmap_icon cl_icon_"+cluster_id+"'>"+this.show_num(count)+"</div>",
                  iconSize: [40, 40],
                  popupAnchor: [0, -10],
                  //iconAnchor: [15, 42]
                });
                l_marker=window.L.marker([lat_avg, lon_avg], {draggable:false, icon:l_icon});

                let f_click=()=>{
                  this.l_map.flyTo([lat_avg,lon_avg], next_zoom );
                };
                l_marker.on('click', ()=>{ f_click() });

                if ( radius_in_pixels>min_radius ){
                  let l_circle=window.L.circle([lat_avg,lon_avg], {radius:radius, color:'#ffffff', fillColor:'#262626', fillOpacity:0.5});
                  l_circle.addTo(this.layer_group);
                  l_circle.on('click', () => {f_click()});

                  this.l_layers[ cluster_id ]=l_circle;
                }
              }

              l_marker.addTo(this.marker_group);
              this.l_markers[ cluster_id ]=l_marker;
            });
          }
          else {
            //удаляем все маркеры
            this.marker_group.clearLayers();
            this.l_markers={};

            this.layer_group.clearLayers();
            this.l_layers={};
          }

        } );
      },
      _do_update_list(lb_lat, lb_lon, rt_lat, rt_lon, zoom){
        //получаем работы в списке
        this.$store.dispatch('getWorksOnMapList', {lb_lat:lb_lat, lb_lon:lb_lon, rt_lat:rt_lat, rt_lon:rt_lon, zoom:zoom, p:1}).then( ()=>{
          this.list_works.splice(0);
          this.list_works_page=1;

          let works=this.$store.getters.works_on_map_list;
          if ( works!=null ){
            //все работы в список
            works.forEach( (work, n)=> {
							this.list_works.push(work);
						});
          }

        } );
      },

      _do_load_list_next(){
        if ( this.list_works.length>=this.$store.getters.works_on_map_list_total ) return;
        if ( this.is_load_works ) return;
        this.is_load_works=true;

        let bounds=this.l_map.getBounds();

        let lb_lat=bounds.getSouthWest().wrap().lat;
        let lb_lon=bounds.getSouthWest().wrap().lng;
        let rt_lat=bounds.getNorthEast().wrap().lat;
        let rt_lon=bounds.getNorthEast().wrap().lng;
        let zoom=this.l_map.getZoom();

        this.list_works_page++;
        this.$store.dispatch('getWorksOnMapList', {lb_lat:lb_lat, lb_lon:lb_lon, rt_lat:rt_lat, rt_lon:rt_lon, zoom:zoom, p:this.list_works_page}).then( ()=>{
          let works=this.$store.getters.works_on_map_list;
          if ( works!=null ){
            //все работы в список
            works.forEach( (work, n)=> {
              this.list_works.push(work);
            });
          }
          this.is_load_works=false;
        } );
      },
      _do_load_popup_next(cluster_id, popup, j_map_ul_popup){
        let lis=$('li', j_map_ul_popup);
        if ( lis.length>=this.$store.getters.works_on_map_cluster_total ) return;
        if ( this.is_load_popup_works ) return;
        this.is_load_popup_works=true;

        let zoom=this.l_map.getZoom();

        this.popup_works_page++;
        this.$store.dispatch('getWorksOnMapCluster', {cluster_id:cluster_id, zoom:zoom, p:this.popup_works_page}).then( ()=>{
          let works=this.$store.getters.works_on_map_cluster;
          if ( works!=null ){
            j_map_ul_popup.append( this.get_popup_html_lis(works) );
          }
          this.is_load_popup_works=false;
        } );

        //
        //this.get_popup_html_lis(works)
        //popup.setContent( this.get_popup_html(works)+this.get_popup_html(works) );
        //popup.update();
      },

    },
  }
</script>



// WEBPACK FOOTER //
// src/components/list/filter/onMap.vue